module.exports = __webpack_public_path__ + "static/media/canvas_accents.0c52e756.svg";